import { Component, Input, Output, ViewEncapsulation, EventEmitter, ViewChild, ElementRef } from "@angular/core";

@Component({
    selector: "pme-accordion-item",
    templateUrl: "./accordion-item.component.html",
    styleUrls: ["./accordion-item.component.scss"],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class AccordionItemComponent {
  @Output() onToggle = new EventEmitter<boolean>();

  @Input() expandDirection: 'up' | 'down' = 'down'; //direção da expansão

  @ViewChild("accordionContent") content: ElementRef;

  expanded: boolean = false;
  contentHeight: string = "0";

  toggle(): void {
    this.expanded = !this.expanded;
    let minimumHeight = this.content.nativeElement.scrollHeight;
    this.contentHeight = this.expanded ? minimumHeight + "px" : "0";
    this.onToggle.emit(this.expanded);
  }
}
